
import Vue from 'vue'
import { mapGetters } from 'vuex'
import { IActivePopupActions } from './../types'

const popupChunksRequires = require.context('./../../../components/', true, /\.popup-chunk\.vue$/i)
const popupChunks = popupChunksRequires.keys().reduce((acc: any, curr: string) => {
  const parsed = require('./../../../components/' + curr.substring(2))
  acc[parsed.default.extendOptions.name] = parsed.default
  return acc
}, {})

function keyupEnterHandler () {
  const accentActions = this.popupState.actions.filter((action: IActivePopupActions) => action.isAccent)
  if (accentActions.length === 1) {
    accentActions[0].callback()
  }
}

export default Vue.extend({
  name: 'Popup',
  computed: {
    ...mapGetters('popupModule',
      {
        isActive: 'getPopupIsOpened',
        popupState: 'getActivePopup'
      }
    )
  },
  created (): void {
    const vm = this as any
    document.addEventListener('keyup', (event: KeyboardEvent) => {
      if (this.isActive) {
        switch (event.key.toLowerCase()) {
          case ('escape'): {
            if (this.letDefaultClose) {
              vm.$store.dispatch('popupModule/setClosed')
            }
            break
          }
          case ('enter'): {
            keyupEnterHandler.call(this)
            break
          }
          default: {
          }
        }
      }
    })
  },
  components: popupChunks
})
